import InsightsResourceCards from './InsightsResourceCards';

export { type InsightsResourceCardsProps } from './InsightsResourceCards';
export default InsightsResourceCards;
